module.exports = __webpack_public_path__ + "img/جیب-دار-طرح-موج.059021a4.png";